import { Component, OnInit, ViewChild, Input, ElementRef, EventEmitter, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PRODUCT_CONFIG, DICE_RENEWALS_CONFIG, FILE_UPLOAD_CONFIG, RENEWAL_MSGS } from '../../../_common/product-config';
import { RenewalBillType } from '../../_models/renewal';
import { CommonPolicyDetails, AdditionalChangesCoverage, TRIACoverage, CyberCoverage, AutoCoverage, WCCoverage, BindRenewal, BindRenewalData } from '../../_models/bind-renewal';
import { BillingType, DocumentFileType, DoNotRenewalPolicyReasons, YesNo, DefaultPaymentPlan, RenewalPolicyOptionsValue, RenewalCoverageAcceptOptionsValue, LOBTypeFullName, PolicyProductName, RenewalBindCoverages, RenewalType  } from '../../../_common/_enum/module.enum';
import { RenewalsService } from '../../_services/renewals.service';
import { SortEvent } from 'src/app/_directives/sortable.directive';
import { Coverage, Coverages } from 'src/app/dice/_models/dice-quote';
import { Quote } from '@angular/compiler';
import { HeaderData } from 'src/app/_models/header-data';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-bind-and-issue-basic-info',
  templateUrl: './bind-and-issue-basic-info.component.html',
  styleUrls: ['./bind-and-issue-basic-info.component.scss']
})
export class BindAndIssueBasicInfoComponent implements OnInit {
  private headerData: HeaderData;

  @Input() lookupReferenceData: any;

  constructor(private renewalsService: RenewalsService, private readonly route: ActivatedRoute, private el: ElementRef, private readonly router: Router, private commonService: CommonService) { }
  
  private billingTypeEnum = BillingType;
  private bannerMsgs = DICE_RENEWALS_CONFIG.BannerMessages;
  private productConfig = PRODUCT_CONFIG;
  private renewalConfig = DICE_RENEWALS_CONFIG;
  private renewalPolicyOptionsValue = RenewalPolicyOptionsValue;
  private renewalCoverageAcceptOptionsValue = RenewalCoverageAcceptOptionsValue;
  private errorMessages = DICE_RENEWALS_CONFIG.FormErrorMessages;
  private renewalMsgs = RENEWAL_MSGS;
  private renewalBillTypeConfig = RenewalBillType;
  private RenewalBindCoverages = RenewalBindCoverages;
  private RenewalCoverageAcceptOptionsValue = RenewalCoverageAcceptOptionsValue;
  private todayDate = new Date();

  /** Below variables can be deleted once testing is complete */
  private policyCoverages = CommonPolicyDetails;
  private additionalChangesCoverage = AdditionalChangesCoverage;
  private triaCoverage = TRIACoverage;
  private cyberCoverage = CyberCoverage;
  private autoCoverage = AutoCoverage;
  private wcCoverage = WCCoverage;

  private DoNotRenewalPolicyReasons = DoNotRenewalPolicyReasons;
  private documentFileTypeEnum = DocumentFileType;
  private YesNoEnum = YesNo;
  private fileUploadConfig = FILE_UPLOAD_CONFIG;
  private defaultPaymentPlanEnum = DefaultPaymentPlan;//AtLeastOneOptionRequired  
  
  private bniFormModel: any;   //BindAndIssue Form Model For Submit
  private bindData: any; //While fetching Bind data on initial screen load
  private uploadedFileSize: number = 0;
  private bniFormSubmitBtnClicked: boolean = false;
  private bniFormSubmitted: boolean = false;  
  private supportingDocuments = [];
  private renewalNumber: any;
  private doNotRenewReasonList: any = [];
  private isDoNotRenewReason = false;

  private loading: boolean = false;
  private apiLoading: boolean = false;
  private isSubmitted: boolean = false;

  private directPaymentPlans: any;
  private agencyPaymentPlans: any;

  private bindBasicInfo: BindRenewal;
  private renewalData: any;
  private renewalAccountData;
  private attachmentError: string = "";
  private triaAttachError: string = "";
  private wcOfficerAttachError: string = "";
  private allDocuments = [];
  private displayWCCertifyCheck: boolean = false;
  private isPrimaryLineDisabled: boolean = false;

  @Output() attachFileSize = new EventEmitter<any>();

  @ViewChild("bniBasicInfoForm", { static: false }) bniBasicInfoForm: NgForm;
  @ViewChild('attachments', {static: false}) attachments;

  ngOnInit() {
    /* Setting Headers Starts */
      this.headerData = new HeaderData();
      this.setHeaderData();
    /* Setting Headers Ended */
    this.route.paramMap.subscribe(params => {
      this.renewalNumber = parseInt(params.get("id"));
    });
    //this.bniFormModel = new BindForm();
    console.log('this.lookupReferenceData :: ', this.lookupReferenceData);
    this.initializeCallsForPageLoad(this.lookupReferenceData);
  }
  setHeaderData(){
    this.headerData.pageTitle = "Bind Request";

    this.renewalsService.header = this.headerData;
  }

  getBindRenewal(){
    return this.renewalsService.renewal;
  }

  initializeCallsForPageLoad(_referenceData) {
    this.renewalAccountData = this.renewalsService.getRenewalAccountData();
    console.log('this.renewalAccountData :: ', this.renewalAccountData);

    this.bindBasicInfo = this.getBindRenewal();
    this.renewalData = this.bindBasicInfo.renewalData;

    console.log('this.bindBasicInfo :: ', this.bindBasicInfo);
    console.log('this.renewalData :: ', this.renewalData);
    this.setSeparatePaymentPlanList(_referenceData.paymentPlans);
    this.setDoNotRenewReason(_referenceData.doNotRenewReason);

    if(!this.bindBasicInfo.fromReview){
      this.fetchBindDetails();
    }

    this.supportingDocuments = this.renewalsService.getSupportingDocuments();
    this.uploadedFileSize = 0;
    this.supportingDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.attachFileSize.emit(this.uploadedFileSize);
  }

  fetchBindDetails() {
    this.loading = true;
    this.apiLoading = true;
    let renewalBindDataSubscription = this.renewalsService.initRenewalData(RenewalType.BIND , this.renewalAccountData.data).subscribe(response => {
      this.bindData = response;
      console.log('this.bindData :: ', this.bindData);
      this.initializeBindForm();
      setTimeout(() => {
        this.loading = false;
        this.apiLoading = false;
      }, 100);
    }, error=>{
      this.loading = false;
      this.apiLoading = false;
    });
    
    this.renewalsService.runningServices.push(renewalBindDataSubscription);
  }

  get isAPILoaded(): boolean{
    return !this.apiLoading;
  }

  setFileIcon(file: any){
    return this.commonService.setFileIcon(file);
  }
  
  initializeBindForm() {
    this.renewalData.accountName = this.bindData.accountName;
    let todaysDate = new Date();
    
    this.renewalData.renewalNumber = this.renewalNumber;
    let _renewalData = this.renewalData;
    _renewalData.expiringPolicies = this.bindData.renewingPolicies;
    _renewalData.expiringPolicies.map(policy => {
      policy.quoteDocuments.map(doc => {
        let docExpiredDate = new Date(doc.dateExpired);
        doc.isDisabled = false;
        doc.isExpired = docExpiredDate < todaysDate;
      });
    });

    this.bindData.renewingPolicies.forEach(renewingpolicy => {
      renewingpolicy.quoteDocuments.map(quote => {
        let selectedQuoteDateExpired = new Date(quote.dateExpired);
        quote.isSelected = false;
        quote.isExpired = selectedQuoteDateExpired < todaysDate;
      });
      
      let tempCommonPolicyDetails = new CommonPolicyDetails();

      tempCommonPolicyDetails.policyNumber = renewingpolicy.policyNumber;
      tempCommonPolicyDetails.productName = renewingpolicy.productName;
      tempCommonPolicyDetails.isPrimaryLine = renewingpolicy.isPrimaryLine;
  
      //_renewalData.expiringPolicies.push(renewingpolicy);
      _renewalData.renewingPolicies.push(tempCommonPolicyDetails);
    });

    console.log('this.renewalData :: 111 ::: ',_renewalData);

    _renewalData.renewingPolicies.forEach((modelPolicy, index) => {
      console.log('modelPolicy :: ', modelPolicy);
      modelPolicy.isSubjectivities = _renewalData.expiringPolicies[index].subjectivities && _renewalData.expiringPolicies[index].subjectivities.length > 0;
     
      if(this.hasPkgPolicy(_renewalData.expiringPolicies[index])) {
        console.log("1");
        let isTriaCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'Tria');
        //return this.bindData.renewingPolicies.find(_policy => _policy.productName.includes(PolicyProductName.Automobile));
        if(modelPolicy.coverages && !isTriaCoverage)
          modelPolicy.coverages.push(new TRIACoverage());

        console.log('modelPolicy.lobs :: ', _renewalData.expiringPolicies[index].lobs);
        
        if(_renewalData.expiringPolicies[index].lobs && _renewalData.expiringPolicies[index].lobs.length > 0) {
          if(this.hasGlLob(_renewalData.expiringPolicies[index]) || this.hasPropertyLob(_renewalData.expiringPolicies[index])) {
            let isCyberCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'Cyber');
            if(modelPolicy.coverages && !isCyberCoverage)
              modelPolicy.coverages.push(new CyberCoverage());
          }
          if(this.hasAutoLob(_renewalData.expiringPolicies[index])) {
            let isAutoCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'Auto');

            if(modelPolicy.coverages && !isAutoCoverage)
              modelPolicy.coverages.push(new AutoCoverage());
          }
        }

        console.log('isTriaCoverage :: ', isTriaCoverage);
      }else if(this.hasAUPolicy(_renewalData.expiringPolicies[index])) {
        console.log("4");
        modelPolicy.coverages.push(new AutoCoverage());
      }else if (this.hasWcPolicy(_renewalData.expiringPolicies[index])) {
        console.log("3");
        let isWCCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'WorkersCompensation');
        if(modelPolicy.coverages && !isWCCoverage)
          modelPolicy.coverages.push(new WCCoverage());
      }else if (this.hasGLPolicy(_renewalData.expiringPolicies[index]) || this.hasPropertyPolicy(_renewalData.expiringPolicies[index])) {
        console.log("2");
        let isTriaCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'Tria');
        if(modelPolicy.coverages && !isTriaCoverage)
          modelPolicy.coverages.push(new TRIACoverage());
        
        let isCyberCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'Cyber');
        if(modelPolicy.coverages && !isCyberCoverage)
          modelPolicy.coverages.push(new CyberCoverage());
      } else if (this.hasIMPolicy(_renewalData.expiringPolicies[index])) {
        console.log("5");
        let isTriaCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'Tria');
        if(modelPolicy.coverages && !isTriaCoverage)
          modelPolicy.coverages.push(new TRIACoverage());
      }else if (this.hasUmPolicy(_renewalData.expiringPolicies[index])) {
        console.log("6");
        let isTriaCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'Tria');
        if(modelPolicy.coverages && !isTriaCoverage)
          modelPolicy.coverages.push(new TRIACoverage());
      }else if (this.hasExcessPolicy(_renewalData.expiringPolicies[index])) {
        console.log("7");
        let isTriaCoverage =  modelPolicy.coverages.find(coverage => coverage.name === 'Tria');
        if(modelPolicy.coverages && !isTriaCoverage)
          modelPolicy.coverages.push(new TRIACoverage());
      }
      
      let isAdditionalChanges = modelPolicy.coverages.find(coverage => coverage.name === 'AdditionalCoverage');
      if(modelPolicy.coverages && !isAdditionalChanges)
        modelPolicy.coverages.push(new AdditionalChangesCoverage());
    });
    console.log('_renewalData :: ', _renewalData)
    this.renewalData = _renewalData;
    this.bindData.renewingPolicies.sort((a, b) =>  (b.isPrimaryLine - a.isPrimaryLine));
    this.renewalData.renewingPolicies.sort((a, b) =>  (b.isPrimaryLine - a.isPrimaryLine));
    console.log('this.renewalData.renewingPolicies :: ', this.renewalData.renewingPolicies);
    console.log(this.bindBasicInfo);
  }

  setSeparatePaymentPlanList(_paymentplans) {
    let _billingTypeEnum = this.billingTypeEnum;

    this.directPaymentPlans = _paymentplans.filter(function(_plan) {
      return _plan.billingType === _billingTypeEnum.Direct;
    });
    this.agencyPaymentPlans = _paymentplans.filter(function(_plan) {
      return _plan.billingType === _billingTypeEnum.Agency;
    });

    console.log("Payment Plans !!!!");
    console.log(this.directPaymentPlans, " :: ", this.agencyPaymentPlans);
  }

  setPaymentPlanCode(_payment) {
    console.log('plan :: ', _payment);
    this.renewalData.paymentPlanCode = _payment.values;
    this.renewalData.paymentPlan = _payment.paymentType;
  }

  updateBillType(event, _billId) {
    this.renewalData.billingType = _billId;
    this.renewalData.paymentPlan = "";
    this.renewalData.paymentPlanCode = "";
    this.renewalData.payment = "";
    console.log('this.renewalData.billingType :: ', this.renewalData.billingType);
    console.log('this.renewalData.payment :: ', this.renewalData.payment);
  }

  setDoNotRenewReason(_reasons) {
    this.doNotRenewReasonList = [];
    //this.RenewalBasicInfoData.DONOT_RENEW_REASON = _data.doNotRenewReason.map((_reason, _index) => {return { "id":  _index+1, "type": _reason.toLowerCase(), "displayName": _reason, "isSelected": false }});
    _reasons.forEach((reason, index) => {
      let object = {
        id: index,
        type: reason.toLowerCase(),
        displayName: reason,
        isSelected: false
      }
      this.doNotRenewReasonList.push(object);
    });
    console.log(this.doNotRenewReasonList);
  }

  updateDoNotRenewReason(renewingPolicy, reason, policy) {
    renewingPolicy.doNotRenewReason = reason.displayName;
    policy = reason.displayName;
  }

  isPrimaryLineNotRenewing() {
    return this.renewalData.renewingPolicies.find(_policy => _policy.isPrimaryLine == true && _policy.renewOption == RenewalPolicyOptionsValue.DO_NOT_RENEW);
  }

  hasAUPolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.Automobile);
  }

  hasPkgPolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.Package);
  }

  hasIMPolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.InlandMarine);
  }

  hasGLPolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.GeneralLiability);
  }

  hasWcPolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.WorkersCompensation);
  }

  hasUmPolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.Umbrella);
  }

  hasExcessPolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.Excess);
  }

  hasPropertyPolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.Property);
  }

  hasCrimePolicy(_policy) {
    return _policy.productName.includes(PolicyProductName.Crime);
  }

  hasGlLob(_policy) {
    return _policy.lobs.find(_lob => _lob.includes(LOBTypeFullName.GeneralLiability));
  }

  hasAutoLob(_policy) {
    return _policy.lobs.find(_lob => (_lob.includes(LOBTypeFullName.Automobile) || _lob.includes(LOBTypeFullName.AutomobileMA)));
  }

  hasPropertyLob(_policy) {
    return _policy.lobs.find(_lob => _lob.includes(LOBTypeFullName.Property));
  }

  /**** Sorting Code ****/
  sortPolicyQuotes() {
    this.bindData.renewingPolicies.map((policy) => {
      policy.quoteDocuments.sort((a,b) => a.dateCreated.localeCompare(b.dateCreated));
    });
  }
  /* Sorting Code */

  assignSelectedQuote (_currentPolicy, _quote) {
    let primaryLinePolicy = this.isPrimaryLineNotRenewing();
    if(_quote !== this.renewalPolicyOptionsValue.DO_NOT_RENEW) {
      _currentPolicy.quoteDocument = _quote;
      _currentPolicy.doNotRenewReason = '';
      _currentPolicy.remarks = '';

      if(_currentPolicy.isPrimaryLine) {
        this.isPrimaryLineDisabled = false;
        this.renewalData.expiringPolicies.map((policy, index) => {
          if(!_currentPolicy.quoteDocument && _currentPolicy.policyNumber !== policy.policyNumber) {
            this.renewalData.renewingPolicies[index].renewOption = "";
          }
          policy.quoteDocuments.forEach(doc => { doc.isDisabled = false; });
        });
      }
    } 
    else {      
      _currentPolicy.quoteDocument = null;
      console.log('this.isPrimaryLineNotRenewing() :: ', primaryLinePolicy);
      if(primaryLinePolicy && primaryLinePolicy.policyNumber === _currentPolicy.policyNumber) {
        this.isPrimaryLineDisabled = true;
        this.renewalData.expiringPolicies.map((policy, index) => {
          if(primaryLinePolicy.policyNumber !== policy.policyNumber) {
            //if (this.renewalData.renewingPolicies[index].renewOption != this.renewalPolicyOptionsValue.DO_NOT_RENEW){
            this.renewalData.renewingPolicies[index].renewOption = "";
            policy.expiredQuoteSelected = false;
            //}
            this.renewalData.renewingPolicies[index].quoteDocument = null;
            //console.log('this.renewalData.renewingPolicies[index] :: ', this.renewalData.renewingPolicies[index]);
            policy.quoteDocuments.forEach(doc => { doc.isDisabled = true; });
          }            
        });
      }
    }
    
  }

  addRemoveTriaCoverageOptions(coverage, optIdx, action) {
    let tempDeclinedOption = {
        keyValueID: 'DeclinedAction',
        fullText: 'Please select one of the following:',
        shortText: 'Declined Action',
        description: '',
        value: null,
        additionalInfo: null,
        isRequired: false
    };
    let tempWaiverFile = {
        keyValueID: 'WaiverAction',
        fullText: 'Please upload a TRIA Waiver.',
        shortText: 'Waiver Action',
        description: '',
        value: null,
        additionalInfo: null,
        isRequired: false
    }

    console.log('coverage.options-before :: ', coverage.options);

    if(action === 'add') {
      coverage.options.push(tempDeclinedOption);
    } else {
      if(coverage.options.length > 1) {
        coverage.options.splice(optIdx, 1);
      }     
    }

    console.log('coverage.options-after :: ', coverage.options);
  }

  resetAutoCoverageOptions(coverage, action) {
    if(action === 'remove') {
      coverage.options.map((option, index) => { if(index !== 0) option.value = null });
    }

    console.log('coverage.options-after :: ', coverage.options);
  }

  fileBrowseHandler(files, fileType, _groupNumber = 0, _coverage = null) {
    this.uploadAllDocuments(files, fileType, _groupNumber, _coverage);
  }

  /* uploadAllDocuments(files, policyNo, _docFileType, coverageDocuments){ */
  uploadAllDocuments(files, _docFileType, _groupNumber = 0, _coverage = null){
    if(files.currentTarget && files.currentTarget.files){
      files = files.currentTarget.files;
    }

    if (files.length == 0) {
      console.log("No file selected!");
      return;
    }
    
    this.allDocuments = this.renewalsService.getSupportingDocuments();
    console.log('Upload - AllDocuments : ', this.allDocuments);

    this.uploadedFileSize = 0;
    this.allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    console.log('allDocuments :: ', this.allDocuments);
    if(_docFileType == this.documentFileTypeEnum.Other){
      this.attachmentError = null;
    }else if(_docFileType == this.documentFileTypeEnum.TriaWaiver){
      this.triaAttachError = null;
    }else if(_docFileType == this.documentFileTypeEnum.IncludedExcludedOfficers){
      this.wcOfficerAttachError = null;
    }
    Array.from(files).forEach((_file:any)=>{
      _file.docFileType = _docFileType;
      _file.groupNumber = _groupNumber;
      _file.uniqueName = (Math.random() * 1000000000).toFixed(0);
      //console.log('_file :: ', _file);
      if(_file.size>0 && (this.uploadedFileSize+(Number(_file.size)))<this.fileUploadConfig.MaxUploadSize){
        this.uploadedFileSize+=(Number(_file.size));
        this.renewalsService.addSupportingDocument(_file);
      }else if(_file.size == 0){
        if(_docFileType == this.documentFileTypeEnum.Other){
          this.attachmentError = this.fileUploadConfig.AttachmentNoContent;
        }else if(_docFileType == this.documentFileTypeEnum.TriaWaiver){
          this.triaAttachError = this.fileUploadConfig.AttachmentNoContent;
        }else if(_docFileType == this.documentFileTypeEnum.IncludedExcludedOfficers){
          this.wcOfficerAttachError = this.fileUploadConfig.AttachmentNoContent;
        }
        console.log("File has no content");
      }else{
        if(_docFileType == this.documentFileTypeEnum.Other){
          this.attachmentError = this.fileUploadConfig.AttachmentExceeds;
        }else if(_docFileType == this.documentFileTypeEnum.TriaWaiver){
          this.triaAttachError = this.fileUploadConfig.AttachmentExceeds;
        }else if(_docFileType == this.documentFileTypeEnum.IncludedExcludedOfficers){
          this.wcOfficerAttachError = this.fileUploadConfig.AttachmentExceeds;
        }
        console.log("File size exceeding");
      }

      if(_docFileType !== this.documentFileTypeEnum.Other) {
        _coverage.isFileAdded = true;
        if(_file.docFileType == this.documentFileTypeEnum.IncludedExcludedOfficers && _file.groupNumber == _groupNumber) {
            _coverage.options[0].value = this.renewalCoverageAcceptOptionsValue.IncludedExcludedOfficers;
        }
      }
    });
    this.attachFileSize.emit(this.uploadedFileSize);
    this.supportingDocuments = this.allDocuments;
  }

  removeAllDocument(_docFileType, _groupNumber = 0, _coverage = null) {
    let allDocuments = this.renewalsService.getSupportingDocuments();
    //let _allDocuments = allDocuments.find(_docFile => { return _docFile.groupNumber == _groupNumber });
      
    allDocuments.forEach((_docFile, fileIndex) => {
      if(_docFile.groupNumber == _groupNumber){
        allDocuments.splice(fileIndex, 1);
      }
    });

    _coverage.isFileAdded = false;
     
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.attachFileSize.emit(this.uploadedFileSize);
    if(_docFileType == this.documentFileTypeEnum.Other){
      this.attachmentError = null;
    }else if(_docFileType == this.documentFileTypeEnum.TriaWaiver){
      this.triaAttachError = null;
    }else if(_docFileType == this.documentFileTypeEnum.IncludedExcludedOfficers){
      this.wcOfficerAttachError = null;
    }
  }

  removeDocument(_uniqueName, _docFileType, _groupNumber = 0, _coverage = null){
    let allDocuments = this.renewalsService.getSupportingDocuments();
    let isWCDocument = false;
    let fileIndex = allDocuments.findIndex(_docFile=>{return _docFile.uniqueName == _uniqueName && _docFile.groupNumber == _groupNumber});
    allDocuments.splice(fileIndex, 1);
    console.log('Remove - all documents : ', allDocuments);
    if(allDocuments.length === 0 && _docFileType !== this.documentFileTypeEnum.Other) {
      _coverage.isFileAdded = false;
    } else if (allDocuments.length > 0 && _docFileType !== this.documentFileTypeEnum.Other && _coverage.isFileAdded) {
      _coverage.isFileAdded = allDocuments.some(_doc => (_docFileType === this.documentFileTypeEnum.IncludedExcludedOfficers || _docFileType === this.documentFileTypeEnum.TriaWaiver) && _doc.groupNumber == _groupNumber);
    }

    if(_docFileType === this.documentFileTypeEnum.IncludedExcludedOfficers && !_coverage.isFileAdded) {
      _coverage.options[0].value = null;
    }

    console.log('_coverage - remove :: ', _coverage);

    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.attachFileSize.emit(this.uploadedFileSize);
    if(_docFileType == this.documentFileTypeEnum.Other){
      this.attachmentError = null;
    }else if(_docFileType == this.documentFileTypeEnum.TriaWaiver){
      this.triaAttachError = null;
    }else if(_docFileType == this.documentFileTypeEnum.IncludedExcludedOfficers){
      this.wcOfficerAttachError = null;
    }
  }

  getSupportingDocuments(_docFileType, _groupNumber=0){
    //console.log('Get Supporting Documents :: _docFileType :: ', _docFileType);
    let docFiles = this.renewalsService.getSupportingDocuments().filter(_docFile=>{return _docFile.docFileType == _docFileType && _docFile.groupNumber == _groupNumber});
    //console.log(docFiles);
    if(_docFileType === this.documentFileTypeEnum.IncludedExcludedOfficers && docFiles.length > 0) {
      this.displayWCCertifyCheck = true;
    } else if(_docFileType === this.documentFileTypeEnum.IncludedExcludedOfficers && docFiles.length === 0) {
      this.displayWCCertifyCheck = false;
    }
    return docFiles;
  }

  onContinue():boolean{
    this.isSubmitted = true;
    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
      return;
    }

    this.bindBasicInfo.renewalData = this.renewalData;

    this.renewalsService.storeRenewalBindData(this.bindBasicInfo);

    return (this.bniBasicInfoForm.valid);
  }
}
